export default "__VITE_ASSET__HsL0zA9O__"